<template>
  <section>
    <el-row style="padding:15px;background:#fff">
      <el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
          <el-input
            @clear="getList"
            @keyup.enter.native="getList"
            ref="input"
            class="search xs24"
            v-model="pdata.kw"
            clearable
            placeholder="请输入渠道名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
          <el-input
            @clear="getList"
            @keyup.enter.native="getList"
            ref="input"
            class="search xs24"
            v-model="pdata.issued_app_name"
            clearable
            placeholder="请输入发行游戏名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
           <el-select  v-model="pdata.company_id"  clearable filterable placeholder="请选择对应公司">
              <el-option v-for="item in companys" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
          </el-select>
          <!--<el-input
            @clear="getList"
            @keyup.enter.native="getList"
            ref="input"
            class="search xs24"
            v-model="pdata.company"
            clearable
            placeholder="请输入公司名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>-->
          <el-select v-model="pdata.type" placeholder="请选择采集来源" clearable>
            <el-option v-for="item,index in config" :key="index+1" :label="item" :value="index+1"></el-option>
          </el-select>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="statusRow">
      <el-button size="small" type="primary" @click="addProduct">新增</el-button>
      <el-button size="small" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="small" type="danger" @click="changeStatus(false,0)">禁用</el-button>
      <el-button size="small" type="info" @click="changeStatus(false,-1)">删除</el-button>
      <el-button size="small" type="primary" @click="batchProduct">批量增加</el-button>
      <el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>
      
    </el-row>

    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
    >
    <!--ald_channel: "广点通中转"
app_name: "一起找不同"
create_time: "1569808409"
id: "1"
issued_app_id: "41"
status: "1"
update_time: "1569808409"
xsl_from: "24129"-->
      <el-table-column type="selection"></el-table-column>
      
      <el-table-column prop="id" label="ID" align="center" width="80px"></el-table-column>
      
      <!--<el-table-column prop="issued_app_id" label="发行游戏ID" align="center"></el-table-column>-->
      <el-table-column prop="app_name" label="发行游戏名称" align="left">
      	 <template slot-scope="scope">
          <el-button type="text" @click="editProduct(scope.row)">{{scope.row.app_name}}</el-button>
        </template>
      </el-table-column>
      
      <!--<el-table-column prop="name" label="渠道名称" align="center" min-width="150px">
        <template slot-scope="scope">
          <el-button type="text" @click="editProduct(scope.row)">{{scope.row.name}}</el-button>
        </template>
      </el-table-column>-->
      


      
      <!--<el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
      
      <el-table-column prop="update_time" label="更新时间" align="center"></el-table-column>-->
      <el-table-column prop="company" label="采集公司" align="center"></el-table-column>
      <el-table-column prop="company_short_name" label="对应公司" align="center"></el-table-column>
      <el-table-column prop="ald_channel" label="对应渠道" align="center"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
       <el-table-column prop="exchange" label="是否换量" align="center">
	       	<template slot-scope="scope">
	           <span v-if="scope.row.exchange==0">否</span>
	           <span v-else-if="scope.row.exchange==1">是</span>
	        </template>
       </el-table-column>
      <el-table-column prop="type" label="采集来源" align="center">
      	<template slot-scope="scope">
           <span v-if="scope.row.type==1">阿拉丁</span>
           <span v-else-if="scope.row.type==2">微信</span>
           <span v-else-if="scope.row.type==3">广点通</span>
           <span v-else-if="scope.row.type==4">内部矩阵</span>
           <span v-else-if="scope.row.type==5">阿拉丁换量</span>
        </template>
      </el-table-column>
      <el-table-column prop="atv" label="获客单价" align="center"></el-table-column>
  		<el-table-column prop="click_price" label="点击单价" align="center"></el-table-column>
  		
  		<el-table-column prop="update_time" label="下线时间" align="center">
     		 <template slot-scope="scope">
           <span v-if="scope.row.status!=1">{{scope.row.update_time}}</span>
           <span v-else>&nbsp;</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="渠道状态" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div v-if="pdata.kw==''&&pdata.issued_app_name==''&&pdata.company==''">
    	<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
      
    ></el-pagination>
    </div>
    
<!--"issued_app_id":"",
		"xsl_from":"",
		"ald_channel":"test"
"channel_id": "",-->
    <el-dialog :title="isAdd==true?'新增':'编辑'" :visible.sync="editDialog" width="550px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">
      
         
        <el-form-item label="发行小游戏" prop="issued_app_id">
          <!-- <el-input placeholder="请输入需要导量的小程序"></el-input> -->
          <searchApp
            @getid="res=>{form.issued_app_id=res}"
            @getInfo="r=>{form.app_name=r.name}"
            compare="issued"
            :pholder="form.app_name"
            :platform_id="''"
          ></searchApp>
        </el-form-item>
        
        
        
        <el-form-item label="xsl_from" prop="xsl_from">
          <el-input placeholder="xsl_from" v-model="form.xsl_from" class="w220"></el-input>
        </el-form-item>
       
        <el-form-item label="对应渠道" prop="ald_channel">
          <el-input placeholder="输入阿拉丁后台对应渠道" v-model="form.ald_channel" class="w220"></el-input>
        </el-form-item>
        <el-form-item label="选择对应公司" prop="company_id">
        	<el-select  v-model="form.company_id"  clearable filterable placeholder="请选择对应公司" >
              <el-option v-for="item in companys" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
          </el-select>
         
        </el-form-item>
        <el-form-item label="对应公司" prop="company">
          <el-input placeholder="company" v-model="form.company" class="w220"></el-input>
        </el-form-item>
       
        <el-form-item label="采集来源" >
         		<el-radio-group v-model="form.type">
					   	<el-radio  :label="idx+1" v-for="it,idx  in config" :key="idx">{{it}}</el-radio>
					  </el-radio-group>
        </el-form-item>
        
         <el-form-item label="导量来源" >
         		<el-radio-group v-model="form.data_source">
					   	<el-radio  label="1" key="1">矩阵导量</el-radio>
					   	<el-radio  label="2" key="2">广点通导量</el-radio>
					   	<el-radio  label="3" key="3">外部渠道导量</el-radio>
					  </el-radio-group>
        	</el-form-item>
        
         
        <el-form-item label="是否换量" >
         		<el-radio-group v-model="form.exchange">
         			<el-radio  label="0" key="0">否</el-radio>
					   	<el-radio  label="1" key="1">是</el-radio>
					   	
					  </el-radio-group>
        </el-form-item>
        <el-form-item label="产品归属" >
         		<el-radio-group v-model="form.product_belongs">
					   	<el-radio  label="1" key="1">内部矩阵</el-radio>
					   	<el-radio  label="2" key="2">外部渠道</el-radio>
					  </el-radio-group>
        	</el-form-item>
        <el-form-item label="买量来源" >
         		<el-radio-group v-model="form.buy_source">
         			<el-radio  label="1" key="1">新增</el-radio>
					   	<el-radio  label="2" key="2">活跃</el-radio>
					   	
					  </el-radio-group>
        </el-form-item>
         <el-form-item label="折扣" prop="discount">
          <el-input placeholder="折扣（0-1）" v-model="form.discount" class="w220"></el-input>
        </el-form-item>
         <el-form-item label="获客单价" prop="atv">
          <el-input placeholder="atv" v-model="form.atv" class="w220"></el-input>
        </el-form-item>
        <el-form-item label="点击单价" prop="click_price">
          <el-input placeholder="输入点击单价" v-model="form.click_price" class="w220"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    
    
    <el-dialog title="批量增加" :visible.sync="batchDialog" width="1150px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				 :headers="headers"
				  :on-success="batchSuccess"
				  name="file"
				  :show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips}}</el-col>
       </el-row>
       <el-row :gutter="5" v-for="item,index in batchForm" :key="index" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="2" v-for="(citem,idx) in  item" :key="idx">
       				{{citem}}
       		</el-col>	
       		
       </el-row>
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit" v-if="this.batchTips=='导入预览'">确 定</el-button>
       
      </div>
    </el-dialog>
  </section>
</template>

<script>
// import { getChannelList, sadstatus, saddad } from "../../api/api";
import {
  getChannelList,
  getChannelAdd,
  getChannelEdit,
  getChannelStatus,
  getPlist,
  baseUrl,
  batchAdd,
  getIssuedAldCompany
} from "../../api/api";

export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        channel_id: [
          { required: true, message: "请输入渠道号", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择广告位类型", trigger: "change" }
        ],
        device: [
          { required: true, message: "请选择广告位系统", trigger: "change" }
        ],
        issued_app_id: [
          { required: true, message: "请选择小程序", trigger: "change" }
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "change" }
        ],
        ald_channel: [
          { required: true, message: "请输入对应渠道，必须与阿拉丁后台填写", trigger: "change" }
        ],
        xsl_from: [
          { required: true, message: "请输入xsl_from", trigger: "change" }
        ],
        company_id: [
          { required: true, message: "请选择对应公司", trigger: "change" }
        ],
      },
      pdata: {
        page: 1,
        perpage: 20,
        kw: "",
        issued_app_name:"",
        company:"",
      },
      companys:[],
      iname: "",
      pname: "",
      sText: "请选择广告位状态",
      tText: "请选择广告位类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      batchDialog:false,
      form: {
      	"log":"新增",
      	"issued_app_id":"",
				"xsl_from":"",
				"company":"",
				"company_id":"",
				"atv":"",
				"ald_channel":"",
        "channel_id": "",
        "type":1,
        "exchange":"0",
        "buy_source":"1",
        "click_price":"",
        "data_source":"1",
        "product_belongs":"1",
        "discount":"",
      },
      batchForm:[],
			batchTips:'导入预览',
      isAdd: false,
      cP: {
        issued_channel_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      url:baseUrl+"IssuedAldChannel/preview",
      headers:{
          'token':this.$cookie.getCookie("login")
      }
    };
  },
  methods: {
  	downloadTemp(){
  		window.location.href='/static/channel.csv';
  	},
  	batchSuccess(response, file, fileList){

  		if(response.code==200){
  			this.batchForm=response.data;
  		}
  		
  		
  	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getChannelList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
	   getConfig() {
	     if (this.$store.config) {
	       this.config = this.$store.config.get_channel_price_type;
	     } else {
	       setTimeout(() => {
	         this.getConfig();
	       }, 50);
	     }
	   },
    statueFilter(s) {
      this.sText = s == "" ? "请选择广告位状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择广告位类型" : s;
      this.pdata.type = s;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },

    editProduct(d) {
      this.editDialog = true;
      this.form = JSON.parse(JSON.stringify(d));
      this.form.channel_id = this.form.id;
      this.form.type = parseInt(this.form.type);
      delete this.form.create_time;
      delete this.form.update_time;
      delete this.form.id;
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
      this.$prompt("请输入编辑原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "内容不能为空"
      }).then(({ value }) => {
        if (isSingle) {
          this.cP.channel_id = s.id;
          this.cP.status = s.status == 1 ? "0" : "1";
        } else {
          this.cP.status = s;
        }
        this.cP.log = value;
        getChannelStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
            this.$message({ message: "状态修改成功", type: "success" });
          }
        });
      });
    },
    //批量增加
    batchProduct(){
    	this.batchDialog=true;
    },
    addProduct() {
      this.form = {
      	"issued_app_id":"",
				"xsl_from":"",
        "channel_id": "",
        "company":"",
        "company_id":"",
				"atv":"",
				"type":1,
				"exchange":"0",
				"buy_source":"1",
				"click_price":"",
				"data_source":"1",
        "product_belongs":"1",
        "discount":"",
      };
      this.isAdd = true;
      this.editDialog = true;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          getChannelAdd(this.form, this.$cookie.getCookie("login")).then(
            res => {
              if (res.code == 200) {
                this.getList();
                this.editDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips="导入预览"
    },
    batchSubmit(){
    var p =	{"data":JSON.stringify(this.batchForm)};
    batchAdd(p, this.$cookie.getCookie("login")).then(response => {
        if (response.code == 200) {
         	 if(response.data.length>0){
         	 	 
        			this.batchForm=response.data;
        			this.batchTips="以下数据未成功导入";
        			
        			
         	 }
         	 else{
         	 	 this.$message({ message: "导入成功", type: "success" });
         	 	 this.batchDialog = false;
         	 	 this.batchForm=[];
         	 }
        }
        else{
        	this.$message.error('导入失败');
        	 
        }
     });
    },
    select(s) {
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.channel_id = p.slice(2);
    },
     getCompany(){
    	var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
    	getIssuedAldCompany(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          if(res.data&&res.data.length>0){
	            this.companys=res.data;
          }
          else{
          		this.companys=[];
          }
        }
     });
    },
  },

  mounted() {
    this.getList();
    this.getCompany();
    this.getConfig();
  },
  watch: {
    'pdata': {
    	
      handler(n, o) {

          this.pdata = n;
          this.getList();
       
      },
      deep: true
    }
  }
};
</script>


<style>
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.qddl .el-radio.radio {
  margin: 20px 30px 0px 0;
  width: 120px;
}
.yltt{
	font-size: 24px;
	font-weight: bold;
	margin: 10px 0 5px;
	text-align: center;
}

.yllist{
	font-size: 14px;
	color: #999999;
	text-align: center;
	line-height: 25px;
}
.yllist0{
	font-size: 18px;
	line-height: 30px;
	color: #666666;
}
</style>







// WEBPACK FOOTER //
// channelControl.vue?6bb0041c